/* global axios */
import ApiClient from './ApiClient';

class OpportunityPipelines extends ApiClient {
  constructor() {
    super('pipelines', { accountScoped: true });
  }

  updateStatus(pipelineId) {
    return axios.patch(`${this.url}/${pipelineId}/status`);
  }

  getUsers(pipelineId) {
    return axios.get(`${this.url}/${pipelineId}/users`);
  }

  saveUsers(pipelineId, userIds) {
    return axios.post(`${this.url}/${pipelineId}/users`, {
      user_ids: userIds,
    });
  }

  removeUser(pipelineId, userId) {
    return axios.delete(`${this.url}/${pipelineId}/users/${userId}`);
  }

  removeUsers(pipelineId, userIds) {
    return axios.delete(`${this.url}/${pipelineId}/users`, {
      data: { user_ids: userIds },
    });
  }

  getInboxes(pipelineId) {
    return axios.get(`${this.url}/${pipelineId}/inboxes`);
  }

  saveInboxes(pipelineId, inboxIds) {
    return axios.post(`${this.url}/${pipelineId}/inboxes`, {
      inbox_ids: inboxIds,
    });
  }

  removeInbox(pipelineId, inboxId) {
    return axios.delete(`${this.url}/${pipelineId}/inboxes/${inboxId}`);
  }

  removeInboxes(pipelineId, inboxIds) {
    return axios.delete(`${this.url}/${pipelineId}/inboxes`, {
      data: { inbox_ids: inboxIds },
    });
  }

  getStages(pipelineId) {
    return axios.get(`${this.url}/${pipelineId}/stages`);
  }

  createStage(pipelineId, payload) {
    return axios.post(`${this.url}/${pipelineId}/stages`, {
      pipeline_stage: payload,
    });
  }

  updateStage(pipelineId, stageId, payload) {
    return axios.patch(`${this.url}/${pipelineId}/stages/${stageId}`, {
      pipeline_stage: payload,
    });
  }

  updateStageStatus(pipelineId, stageId, status) {
    return axios.patch(`${this.url}/${pipelineId}/stages/${stageId}/status`, {
      status,
    });
  }

  removeStage(pipelineId, stageId) {
    return axios.delete(`${this.url}/${pipelineId}/stages/${stageId}`);
  }

  reorderStages(pipelineId, stages) {
    return axios.patch(`${this.url}/${pipelineId}/stages/reorder`, { stages });
  }

  getLossReasons(pipelineId) {
    return axios.get(`${this.url}/${pipelineId}/loss_reasons`);
  }

  createLossReason(pipelineId, payload) {
    return axios.post(`${this.url}/${pipelineId}/loss_reasons`, {
      loss_reason: payload,
    });
  }

  updateLossReason(pipelineId, lossReasonId, payload) {
    return axios.patch(
      `${this.url}/${pipelineId}/loss_reasons/${lossReasonId}`,
      {
        loss_reason: payload,
      }
    );
  }

  getNegotiationForm(pipelineId) {
    return axios.get(`${this.url}/${pipelineId}/negotiation_form`);
  }

  createNegotiationForm(pipelineId) {
    return axios.post(`${this.url}/${pipelineId}/negotiation_form`);
  }

  updateNegotiationForm(pipelineId, payload) {
    return axios.patch(`${this.url}/${pipelineId}/negotiation_form`, {
      negotiation_form: payload,
    });
  }

  deleteNegotiationForm(pipelineId) {
    return axios.delete(`${this.url}/${pipelineId}/negotiation_form`);
  }

  createNegotiationQuestion(pipelineId, payload) {
    return axios.post(`${this.url}/${pipelineId}/negotiation_form/questions`, {
      question: payload,
    });
  }

  updateNegotiationQuestion(pipelineId, questionId, payload) {
    return axios.patch(
      `${this.url}/${pipelineId}/negotiation_form/questions/${questionId}`,
      { question: payload }
    );
  }

  deleteNegotiationQuestion(pipelineId, questionId) {
    return axios.delete(
      `${this.url}/${pipelineId}/negotiation_form/questions/${questionId}`
    );
  }

  reorderNegotiationQuestions(pipelineId, questionIds) {
    return axios.patch(
      `${this.url}/${pipelineId}/negotiation_form/questions/reorder`,
      { question_ids: questionIds }
    );
  }
}

export default new OpportunityPipelines();
